import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
    root: {
        paddingTop: '110px',
        paddingBottom:"80px",
        background: 'radial-gradient(circle at 85% 0%, rgba(92, 184, 55, 0.13), transparent 30rem), linear-gradient(180deg, #F7FAF5 0%, #F2F6F0 100%)',
        minHeight: '100vh',
        height: '100%'
    },
    editorRoot: {
        paddingTop: '60px',
        minHeight: '100vh',
        background: '#F3F6F2'
    },
    modalForm: {
        width: '100%'
    },
    layout: {
        width: 'auto',
        display: 'block', // Fix IE11 issue.
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(3 * 2))]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // justifyContent: 'center',
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
    },
    avatar: {
        margin: `${theme.spacing(1)}px auto`,
        backgroundColor: theme.palette.primary.main,
        width: 80,
        height: 80,
        // borderRadius: 0
        '& svg': {
            // color: 'rgba(0, 0, 0, 0.87)',
            color: '#fff'
        }
    },
    form: {
        width: '100%', // Fix IE11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        marginTop: theme.spacing(3),
    },
    fieldError: {
        color: '#FF0000'
    },
    item: {
        '&:not(:last-child)': {
            marginBottom: '0 !important',
            borderBottom: '1px solid #ECECEC'
        },
        '&:hover': {
            cursor: 'default !important',
            '& $itemCheckbox': {
                opacity: '0 !important'
            },
            '& $itemWrapper': {
                boxShadow: 'none !important'
            }
        },
        '& $itemContent': {
            boxShadow: 'none'
        }
    },
    itemColumn: {
        '& img': {
            objectFit: 'contain !important'
        }
    },
    idColumn: {
        width: '500px',
    },
    itemCheckbox: {},
    itemWrapper: {},
    itemContent: {},
    colLineTitle: {
        '&.mainTitle': {
            fontSize: '1rem'
        },
        '&.subTitle': {
            color: '#808080'
        }
    },
    statusBtns: {
        width: '20%',
        maxWidth: '300px',
    },
    statusBtn: {
        margin: '2px 0px',
        width: '100%',
        minHeight: '36px',
        maxWidth: '129px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '3px 25px',
        boxShadow: 'none',
    },
    selectionHero: {
        maxWidth: '680px',
        marginBottom: '36px'
    },
    eyebrow: {
        display: 'block',
        marginBottom: '8px',
        color: '#3A8D1B',
        fontSize: '12px',
        fontWeight: 800,
        letterSpacing: '0.13em'
    },
    selectionTitle: {
        color: '#172313 !important',
        fontSize: '38px !important',
        fontWeight: '750 !important',
        lineHeight: '1.15 !important',
        letterSpacing: '-0.035em !important'
    },
    selectionDescription: {
        marginTop: '10px !important',
        color: '#687364 !important',
        fontSize: '16px !important',
        lineHeight: '24px !important'
    },
    choiceCard: {
        position: 'relative',
        height: '100%',
        overflow: 'hidden',
        border: '1px solid #E2E8DF',
        borderRadius: '18px',
        background: '#FFFFFF',
        boxShadow: '0 12px 34px rgba(31, 52, 24, 0.065)',
        color: '#23301F',
        transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease',
        '&:hover': {
            transform: 'translateY(-5px)',
            borderColor: '#86B774',
            boxShadow: '0 20px 42px rgba(38, 75, 25, 0.13)',
            '& $choiceFooter svg': {
                transform: 'translateX(4px)'
            }
        }
    },
    choicePreview: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '230px',
        overflow: 'hidden',
        background: 'linear-gradient(145deg, #EFF6EC, #F9FBF8)'
    },
    typeBadge: {
        position: 'absolute',
        top: '14px',
        left: '14px',
        padding: '5px 9px',
        border: '1px solid rgba(79, 145, 51, 0.18)',
        borderRadius: '999px',
        color: '#347D18',
        background: 'rgba(255, 255, 255, 0.92)',
        fontSize: '11px',
        fontWeight: 700
    },
    customTypeIcon: {
        width: '72px !important',
        height: '72px !important',
        color: '#78A765'
    },
    choiceContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: '188px',
        padding: '22px'
    },
    typeTitle: {
        fontSize: '20px !important',
        fontWeight: '700 !important',
        color: '#1F2B1B !important'
    },
    typeDescription: {
        marginTop: '8px !important',
        fontSize: '13px !important',
        lineHeight: '20px !important',
        color: '#707A6C !important'
    },
    choiceFooter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '24px',
        paddingTop: '16px',
        borderTop: '1px solid #EEF1EC',
        color: '#378319',
        fontSize: '13px',
        fontWeight: 700,
        '& svg': {
            transition: 'transform 180ms ease'
        }
    },
    deleteTypeButton: {
        position: 'absolute !important',
        top: '12px',
        right: '12px',
        color: '#C34747 !important',
        background: 'rgba(255, 255, 255, 0.92) !important',
        boxShadow: '0 4px 12px rgba(80, 35, 35, 0.1)'
    },
    createTypeCard: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '24px',
        marginTop: '28px',
        padding: '22px 24px',
        border: '1px dashed #BFCDB9',
        borderRadius: '16px',
        background: 'rgba(255, 255, 255, 0.76)',
        [theme.breakpoints.down('sm')]: {
            alignItems: 'stretch',
            flexDirection: 'column'
        }
    },
    createTypeHeading: {
        display: 'flex',
        alignItems: 'center',
        gap: '13px'
    },
    createTypeIcon: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '42px',
        height: '42px',
        color: '#378319',
        background: '#EAF6E5',
        borderRadius: '12px'
    },
    createTypeTitle: {
        color: '#23301F !important',
        fontSize: '16px !important',
        fontWeight: '700 !important'
    },
    createTypeDescription: {
        marginTop: '2px !important',
        color: '#748070 !important',
        fontSize: '12px !important'
    },
    createTypeForm: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        width: '50%',
        '& .MuiButton-root': {
            minWidth: '145px',
            height: '40px',
            borderRadius: '9px',
            background: '#3F921F',
            fontWeight: 700,
            textTransform: 'none'
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            alignItems: 'stretch',
            flexDirection: 'column'
        }
    },
    failureBtn: {
        color: '#E71919',
        border: '1px solid #E71919'
    },
    successBtn: {

    },
    statusBtnDisable: {
        padding: '5px 55px',
        maxWidth: '271px'
    },
    boxStatus: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    detailTextCustomer: {
        fontSize: '12px',
        fontWeight: '400',
        margin: '5px 0px'
    },
    header: {
        position: 'fixed',
        left: '0%',
        right: '0%',
        height: '60px',
        background: '#41B60B',
        color: 'white',
        'z-index': '100',
        'align-items': 'center',
        display: 'flex',
        padding: '0px 42px',
        top: "0%",
    },
    drawIconClose: {
        width: "30px",
        height: "30px",
        color: 'white',
        "& img": {
          width: "20px",
        },
    },
    textClose:{
        'padding-left': '14px',
        'font-size': '18px',
        color: 'white',
        'line-height': '30px',
    },
    wrapIconClose: {
        display: 'flex',
        alignItems:'center',
        cursor: 'pointer'
    },
    itemDetail: {
        width: 'calc(100% - 42px * 2 - 8px * 2)'
    },
    dailyInvoiceDetail: {
        padding: '2rem',
        '&:not(:last-child)': {
            borderBottom: '1px solid #ECECEC'
        }
    },
    currentBalance:{
        color: '#41B60B',
        fontSize: '36px',
        lineHeight: '42px',
        paddingRight: "10px"
    },
    imgProp:{
        width: '100% !important',
        height: '100% !important',
        padding: '20px',
        objectFit: 'contain'
    },
    loading:{
        width: '100%',
        height: '500px',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        fontFamily: 'monospace',
        letterSpacing: '0.5em !important'
    },
    
}))
